module.exports = __webpack_public_path__ + "img/ironing-gray.829ead03.svg";